// Action imports
import { RescheduleAction } from "./reschedule-action";
import { RescheduleRequestAction } from "./reschedule-request-action";
import { AddCommentAction } from "./add-comment-action";
import { CancelAction } from "./cancel-action";
import { CancelRequestAction } from "./cancel-request-action";
import { StatusChangeAction } from "./status-change-action";
import { ASSIGN_ENTRY } from "./assignment-entries";
import { ServiceChangeAction } from "./service-change-action";
import { ViewAppointmentAction } from "./view-appointment-action";
import { RequestReassignmentAction } from "./request-reassignment-action";
import { RequestServiceChangeAction } from "./request-service-change-action";

// Registry
import { actionRegistry } from "../core/action-registry";

// Register all actions
actionRegistry.register(new RescheduleAction());
actionRegistry.register(new RescheduleRequestAction());
actionRegistry.register(new AddCommentAction());
actionRegistry.register(new CancelAction());
actionRegistry.register(new CancelRequestAction());
actionRegistry.register(new StatusChangeAction());
actionRegistry.offer(ASSIGN_ENTRY);
actionRegistry.register(new ServiceChangeAction());
actionRegistry.register(new ViewAppointmentAction());
actionRegistry.register(new RequestReassignmentAction());
actionRegistry.register(new RequestServiceChangeAction());

// Export the registry and core types
export { actionRegistry } from "../core/action-registry";
export * from "../core/base-action";

// Export individual actions for testing or direct use
export {
  RescheduleAction,
  RescheduleRequestAction,
  AddCommentAction,
  CancelAction,
  CancelRequestAction,
  StatusChangeAction,
  ServiceChangeAction,
  ViewAppointmentAction,
  RequestReassignmentAction,
  RequestServiceChangeAction,
};
